import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "sign"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "签名", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "上传签名", -1);
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "footerBtn"
};
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import commonMethod from '../common/common';
import { Dialog } from 'vant';
export default /*#__PURE__*/_defineComponent({
  __name: 'serveComplete',
  setup(__props) {
    const VanDialog = Dialog.Component;
    const router = useRouter();
    const route = useRoute();
    const {
      proxy
    } = getCurrentInstance();
    const orderid = ref(''); //订单id
    const sign_url = ref(''); //签名路径
    const fu_id = ref(''); //签名id
    onMounted(() => {
      if (history.state.order_no) {
        orderid.value = history.state.order_no;
        //获取签名页缓存的签名：
        if (window.localStorage.getItem('sign_url')) {
          sign_url.value = window.localStorage.getItem('sign_url');
          fu_id.value = window.localStorage.getItem('fu_id');
        }
        //获取缓存的服务网点：
        if (window.localStorage.getItem('orderName')) {
          orderName.value = window.localStorage.getItem('orderName');
          oc_id.value = window.localStorage.getItem('oc_id');
        }
      } else {
        commonMethod.dialog('页面加载失败', '页面缺少服务单号', 1);
      }
      //清除缓存：
      window.localStorage.clear();
      initService();
    });
    const columns = ref([]); // 服务商列表接口返回数组
    const columns1 = ref([]); // 服务商列表处理后数组
    const initService = () => {
      proxy.$api.get(`${proxy.$url}Evaluate/getOutComp`, {
        vender_order_no: orderid.value
      }).then(res => {
        columns.value = res.data;
        for (let s of res.data) {
          columns1.value.push(s.oc_name);
        }
      });
    };
    const showPicker = ref(false); //弹窗是否显示
    const oc_id = ref(0); //服务商id
    const orderName = ref(''); // 选择的服务商名称
    // 选择服务商弹窗事件
    const onConfirm = value => {
      Dialog.confirm({
        title: '选择确定',
        message: `<span style="color:#b50029;">${value}</span>` + ' 团队已为您服务完成，是否确认？',
        allowHtml: true
      }).then(() => {
        columns.value.forEach(item => {
          if (item.oc_name == value) {
            oc_id.value = item.oc_id;
          }
        });
        orderName.value = value;
        showPicker.value = false;
      }).catch(() => {});
    };
    // 打开签名弹窗
    const openSign = () => {
      //缓存服务网点：
      window.localStorage.setItem('oc_id', oc_id.value);
      //缓存服务网点：
      window.localStorage.setItem('orderName', orderName.value);
      router.push({
        name: 'sign'
      });
    };
    // 提交
    const submit = () => {
      if (!oc_id.value) {
        commonMethod.notify('warning', '请选择服务网点');
        return;
      }
      proxy.$api.post(`${proxy.$url}Evaluate/completeOrder`, {
        vender_order_no: orderid.value,
        oc_id: oc_id.value,
        fu_id: fu_id.value
      }).then(res => {
        if (res.status) {
          commonMethod.notify('success', '确认完成');
          setTimeout(() => {
            router.go(-1);
          }, 1000);
        }
      }).catch(() => {
        commonMethod.notify('warning', '网络异常，请稍后重试');
      });
    };
    // 返回上一页
    const back = () => {
      window.history.go(-1);
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
        title: "完成服务",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      }), _createVNode(_component_van_field, {
        label: "服务单号",
        modelValue: orderid.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => orderid.value = $event),
        readonly: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "服务网点名称",
        modelValue: orderName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => orderName.value = $event),
        readonly: "",
        clickable: "",
        "right-icon": "arrow",
        placeholder: "请选择服务网点",
        onClick: _cache[2] || (_cache[2] = $event => showPicker.value = true)
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_hoisted_2, !sign_url.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: openSign
      }, [_createVNode(_component_van_icon, {
        name: "plus",
        color: "#969799",
        size: "20"
      }), _hoisted_3])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: openSign
      }, [_createElementVNode("img", {
        src: sign_url.value,
        alt: "",
        class: "sign_url_img"
      }, null, 8, _hoisted_4)]))]), _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => showPicker.value = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          "show-toolbar": "",
          columns: columns1.value,
          onConfirm: onConfirm,
          onCancel: _cache[3] || (_cache[3] = $event => showPicker.value = false)
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        color: "#b50029",
        onClick: submit
      }, {
        default: _withCtx(() => [_createTextVNode("确认完成")]),
        _: 1
      })])], 64);
    };
  }
});